export default "__VITE_ASSET__CusM621Q__"